<template>
  <div>
    <b-modal
      id="modal-create-pin"
      v-model="modalCreatePin"
      size="lg"
      hide-footer
      hide-header
      no-close-on-esc
      no-close-on-backdrop
      centered
    >
      <div class="box-pin mb-5">
        <div class="heading text-center">
          <h3 class="font-rubik-medium mb-3">
            Buat PIN Keamanan Baru
          </h3>
          <p class="font-rubik-regular">
            Silakan buat PIN keamanan Anda
          </p>
        </div>
        <div class="body-pin">
          <div class="flex">
            <div class="flex justify-center mb-10 items-center md:mt-5 relative" style="flex-direction: row;">
              <client-only>
                <v-otp-input
                  ref="otpInput1"
                  :input-classes="!isShowPin1 ? 'otp-input hide-password' : 'otp-input'"
                  input-type="tel"
                  separator=""
                  :num-inputs="6"
                  :should-auto-focus="true"
                  :is-input-num="true"
                  @on-change="handleOnChangePin1"
                  @on-complete="handleCompletePin1"
                />
              </client-only>
              <div class="relative pt-4">
                <font-awesome-icon
                  size="lg"
                  :icon="isShowPin1 ? 'eye' : 'eye-slash'"
                  class="cursor-pointer mt-1"
                  @click="toggleShowPin1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box-pin mb-5">
        <div class="heading text-center">
          <p class="font-rubik-regular">
            Masukkan kembali PIN keamanan Anda
          </p>
        </div>
        <div class="body-pin">
          <div class="flex">
            <div class="flex justify-center mb-10 items-center md:mt-5 relative" style="flex-direction: row;">
              <v-otp-input
                ref="otpInput2"
                :input-classes="generatedClass"
                input-type="tel"
                separator=""
                :num-inputs="6"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-change="handleOnChangePin2"
                @on-complete="handleCompletePin2"
              />
              <div class="relative pt-4">
                <font-awesome-icon
                  size="lg"
                  :icon="isShowPin2 ? 'eye' : 'eye-slash'"
                  class="cursor-pointer mt-1"
                  @click="toggleShowPin2"
                />
              </div>
            </div>
          </div>
          <p v-if="isNotSame" class="wrong-pin-text mt-3 mb-0 font-rubik-regular text-center">
            Konfirmasi PIN keamanan Anda salah
          </p>
        </div>
      </div>
      <div class="box-submit text-center">
        <button
          class="pl-6 text-white"
          :class="isDisabled == true ? 'btn-disabled' : ''"
          :disabled="isDisabled"
          @click="submitPIN"
        >
          <loading-state v-if="onShowLoading" color="white" class="loadingPin" />
          <font-awesome-icon v-if="!isDisabled" icon="check-circle" size="lg" /> Lanjutkan
        </button>
      </div>
    </b-modal>
    <input-pin v-if="showInputPIN" />
  </div>
</template>
<script>
import inputPin from '@/components/modal-dialog/InputPin.vue'
import loadingState from '@/components/LoadingState'
export default {
  components: {
    inputPin,
    loadingState
  },
  data () {
    return {
      modalCreatePin: true,
      pin1: '',
      pin2: '',
      isNotSame: false,
      isShowPin1: false,
      isShowPin2: false,
      isDisabled: true,
      showInputPIN: false,
      onShowLoading: false
    }
  },
  computed: {
    generatedClass () {
      const firstClass = !this.isNotSame ? 'otp-input' : 'otp-input wrong-pin'
      const secondClass = !this.isShowPin2 ? ' hide-password' : ''
      return firstClass + secondClass
    }
  },
  methods: {
    toggleShowPin1 () {
      this.isShowPin1 = !this.isShowPin1
    },
    toggleShowPin2 () {
      this.isShowPin2 = !this.isShowPin2
    },
    handleCompletePin1 (value) {
      this.pin1 = value
      if (this.pin2 === this.pin1) {
        this.isDisabled = false
      } else {
        this.isDisabled = true
      }
    },
    handleCompletePin2 (value) {
      this.pin2 = value
      if (this.pin1 === this.pin2) {
        this.isDisabled = false
        this.isNotSame = false
      } else {
        this.isDisabled = true
        this.isNotSame = true
      }
    },
    handleOnChangePin1 (value) {
      if (value.length !== 6) {
        this.isDisabled = true
      }
    },
    handleOnChangePin2 (value) {
      if (value.length !== 6) {
        this.isDisabled = true
      }
    },
    async submitPIN () {
      this.onShowLoading = true
      this.isDisabled = true
      const formData = new FormData()
      formData.append('PIN', this.pin1)
      formData.append('PIN_confirmation', this.pin2)
      await this.$store.dispatch('user/createPIN', formData)
        .then((res) => {
          this.modalCreatePin = false
          this.$swal({
            width: 630,
            padding: '3em',
            icon: 'success',
            html: '<p style="color: #434343;font-size: 20px;">PIN Keamanan baru telah berhasil dibuat</p>',
            confirmButtonText: 'Tutup',
            customClass: {
              container: 'bg-modal-pin',
              confirmButton: 'btn btn-close',
              popup: 'popup-create-pin'
            }
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload()
            }
          })
        })
        .catch((err) => {
          this.onShowLoading = false
          this.isDisabled = false
          throw new Error(err)
        })
    }
  }
}
</script>

<style lang="scss">
  #modal-create-pin {
    background: #024668d1 !important;
    .modal-body {
      padding: 3rem;
      .heading {
        h3 {
          color: #434343;
          font-size: 24px;
        }
        p {
          color: #434343;
          font-size: 18px;
        }
      }
      .body-pin {
        .flex {
          display: flex;
          input {
            border: 0px;
            width: 80%;
            height: 80px;
            font-size: 60px;
            text-align: center;
            background-color: #f3f2ef;
            &:focus-visible {
              outline: 0px;
            }
            &.wrong-pin {
              border: 1px solid #E70016;
            }

            @media (max-width: 1200px) {
              font-size: 50px;
            }
          }
        }
        p.wrong-pin-text {
          color: #E70016;
        }
      }
      .box-submit {
        button {
          width: 185px;
          height: 40px;
          padding: 0px;
          overflow: hidden;
          position: relative;
          background: #00C300;
          border-radius: 20px;
          border: 1px solid #00C300;
          svg {
            position: absolute;
            left: 10px;
            top: 8px;
          }
          &.btn-disabled {
            background: #bfbfbf;
            border: 1px solid #bfbfbf;
          }
          .loadingPin {
            top: 0;
            width: 100%;
            height: 100%;
            margin: auto;
            padding-top: 7px;
            position: absolute;
            text-align: center;
            background: #00000036;
          }
        }
      }
    }
  }
  .bg-modal-pin {
    background: #024668d1 !important;
    .btn-close {
      width: 150px;
      padding-top: 7px;
      padding-bottom: 7px;
      background: #1A5CAC !important;
      border-radius: 35px !important;
    }
    .popup-create-pin {
      border-radius: 23px;
    }
  }
</style>
